import { SearchComponentEnum } from "@utils/search/@types/searchComponent";
import { SearchComponentConfiguration } from "@utils/search/@types/searchConfiguration";
import { SearchComponentState } from "@utils/search/@types/searchState";

export enum SearchStatus {
    Loading = "LOADING",
    Idle = "IDLE",
    Error = "ERROR",
}

export type AlgoliaParameters = {
    appId?: string;
    searchApiKey?: string;
};

export const $SearchModuleName = "search";

export type SearchConfiguration = {
    query?: string;
    filters?: string;
    categoryPagePaths?: Array<string>;
    userToken?: string;
    components: Array<SearchComponentConfiguration>;
};

export type SearchResults = Array<SearchComponentState>;

export type SearchState = {
    status: SearchStatus;
    algoliaParameters?: AlgoliaParameters;
    configuration: SearchConfiguration;
    results: SearchResults;
};

export type SearchInvalidations = {
    configuration: Array<SearchComponentEnum>;
    state: Array<SearchComponentEnum>;
};
